
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share-updates",
      function () {
        return require("private-next-pages/share-updates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share-updates"])
      });
    }
  